import { createDateMathSubExpression } from '../../utils/createDateMathSubExpression';
import { parseRelativeDateString } from '../../utils/parseRelativeDateString';

import { StringValue } from './StringValue';

export class RelativeDateValue extends StringValue {
  toExpression() {
    const { dateParameter, relativeDateEquation } = parseRelativeDateString(this.value);
    return createDateMathSubExpression(dateParameter, relativeDateEquation);
  }
}
